export default "__VITE_PUBLIC_ASSET__60c1afac__"